import mitt from 'mitt'
export const mittBus = mitt()